exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qmodii .qmod-accord-text{margin-bottom:25px}.qmodii .qmodii-modal-content{width:100%}", ""]);

// exports
